export const CustomerTierSettingsQueryKey = 'customerTierSettings'
export const ProductConfigsQueryKey = 'product-configs'
